module.exports = __webpack_public_path__ + "image/about_image_6_17a71.png";